const FINISHED_DELIVERY_STATUSES = new Set(['interrupted', 'cancelled', 'returned', 'imported', 'complete'])
export const DELIVERY_POLL_MS = 3000
/**
 * A failed delivery is not final: the CLI connector retries it on each of its
 * cycles and may still acknowledge it as imported, so keep checking slowly.
 */
export const FAILED_DELIVERY_POLL_MS = 10_000

/** How often to re-read a Premiere delivery, or null once nothing more can change. */
export function deliveryPollInterval(delivery: { id?: string | null; status?: string | null } | null, imported: boolean) {
  if (!delivery?.id || imported) return null
  const status = String(delivery.status || '').toLowerCase()
  if (FINISHED_DELIVERY_STATUSES.has(status)) return null
  return status === 'failed' ? FAILED_DELIVERY_POLL_MS : DELIVERY_POLL_MS
}
